import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import PaymentEditor from './PaymentEditor';

function AddPayment() {
	const navigate = useNavigate();
	const { state } = useLocation();
	const returnTo = state?.returnTo || '/AdminScreen/payments';

	return (
		<EntityList>
			<Helmet>
				<title>Agregar Cobro</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Cobros', to: '/AdminScreen/payments' },
					{ label: 'Agregar Cobro' },
				]}
				title='Agregar Cobro'
				subtitle='Completá los datos para registrar el cobro.'
			/>
			<PaymentEditor
				mode='create'
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default AddPayment;
